module.exports = __webpack_public_path__ + "static/media/zing.f22dadb1.svg";